<template>
    <div :id="id" class="line" style="width:100%;height:100%;"></div>
</template>
<script>
import * as echarts from 'echarts';
export default{
    props: {
        data: {
            type: Object,
            default: (()=>{
                return {}
            })
        },
    },
    data(){
        return{
            chart:null,
            id:new Date().getTime() * Math.floor(Math.random() * 100) + 1* Math.floor(Math.random() * 100) + 1
        }
    },
    mounted() {
        // this.initChart()
    },
    beforeDestroy() {
        if (!this.chart) {
        return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            var _this = this
            this.chart = echarts.init(document.getElementById(this.id))
            var option = {
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    top:'20%',
                    containLabel: true
                },
                legend: {
                    data: _this.data.xData
                },
                tooltip: {
                    trigger: 'axis'
                },  
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        interval: 0,
                        rotate: 40
                    },
                    data: _this.data.xData
                },
                yAxis: {
                    type: 'value'
                },
                series: _this.data.yData
            };
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                if (this.chart) {
                    this.chart.resize()
                }
            })
        }
    }
}
</script>